import React from 'react';

const ResonanceSettings = () => {
  return <div>ResonanceSettings</div>;
};

export default ResonanceSettings;
